import React from "react";
import {Unauthenticated} from "./unauthenticated";
import {Authenticated} from "./authenticated";
import {AuthState} from "./authState";

export function Login({userName, authState, onAuthChange}) {
    return (
        <div className="login-overlay">
            <div className="login-overlay-content">
                {authState !== AuthState.Unknown && (
                    <>
                        <h1 className="welcome-title">Welcome to Lightning.io</h1>
                        <p className="welcome-subtitle">Fast, secure file sharing made simple</p>
                    </>
                )}
                {authState === AuthState.Authenticated && (
                    <Authenticated userName={userName}
                                   onlogout={() => onAuthChange(userName, AuthState.Unauthenticated)}/>
                )}
                {authState === AuthState.Unauthenticated && (
                    <Unauthenticated userName={userName} onlogin={(loginUserName) => {
                        onAuthChange(loginUserName, AuthState.Authenticated);
                    }}
                    />
                )}
            </div>
        </div>
    );
}